// Globals
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Models
import { IGoogleMerchantSyncRun } from '@/models/googleMerchantSync.model';

// Components
import { Table } from '@/ui';

// Helpers
import { getGoogleMerchantSyncTableColumns } from '../../helpers';

type TGoogleMerchantSyncTableProps = {
  syncRuns: IGoogleMerchantSyncRun[] | null;
  isLoading: boolean;
};

const GoogleMerchantSyncTable: FC<TGoogleMerchantSyncTableProps> = ({ syncRuns, isLoading }) => {
  const { t } = useTranslation(['common']);

  const columns = useMemo(() => getGoogleMerchantSyncTableColumns(t), [t]);

  return (
    <Table
      columns={columns}
      rowKey="id"
      dataSource={syncRuns ?? []}
      loading={isLoading}
      pagination={false}
      virtual
      rowHoverable
    />
  );
};

export default GoogleMerchantSyncTable;
